<template>
  <div>
    <div class='top'>添加人员信息</div>
    <van-cell-group>
      <van-field v-model="name" required clearable label="姓名" placeholder="请输入姓名" />
      <van-field v-model="idCard" required clearable label="身份证号" :formatter="formatter" placeholder="请输入身份证号" />
      <div class="tip">
        *如果查询结果为空，可能以上参与者信息未在系统登记，请联系相关医疗单位。
      </div>
      <van-button type="info" @click="goQuery" class="btn">
        确定
      </van-button>
    </van-cell-group>
  </div>
</template>
<script>
export default {
  name: 'query',
  data() {
    return {
      showAccountTitle: false,
      isWst: false,
      name: '',
      idCard: '',
      code: '',
      phone: '',
      openId: '',
      accountTitle: '',
      wstToken: '',
      isAgree: '',
      hospitalId:''
    };
  },
  mounted() {
    this.openId = this.$route.query.openId;
    this.accountId = this.$route.query.accountId;
    this.hospitalId = this.$route.query.hospitalId;
    this.isAgree = this.$route.query.isAgree;
    this.getTitle();
  },
  methods: {
    formatter(value) {
      // 过滤输入的数字
      return value.replace(/x/g, 'X');
    },
    async getTitle() {
      let auth = this.$createAuth(this.$md5);
      let data = {
        openId: this.openId,
        auth: auth.code,
        time: auth.time
      };
      if (this.accountId != null && this.accountId != '') {
        data.accountId = this.accountId;
      }
      let result = await this.$http.get(this.$url.getTitle, data);
      if (result.message === 'Error: Miss auth parameter.') {
        this.getTitle();
      } else {
        document.title = result.data.title;
      }
      if (result.data.accountTitle != null && result.data.accountTitle != "") {
        this.accountTitle = result.data.accountTitle;
        this.showAccountTitle = true;
      }
      if (this.wstToken != null && this.wstToken != '') {
        document.title = '眼健康在线';
      }
    },
    async goQuery() {
      let auth = this.$createAuth(this.$md5);
      if (this.name == "") {
        this.$toast("请填写姓名！");
        return;
      } else {
      }
      if (this.idCard == "") {
        this.$toast("请填写身份证号码！");
        return;
      }

      if (this.idCard != "") {
        let yz1 = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/.test(this.idCard);
        let yz2 = /(^[a-zA-Z][0-9]{9})|(^[A-Z][0-9]{8})|(^[A-Z][0-9]{6}[(（][0-9a-zA-z][)）])$/.test(this.idCard);
        if (!yz1 && !yz2) {
          this.$toast("身份证号填写错误！");
          return;
        }
      }
      let result = await this.$http.post(this.$url.queryList, {
        auth: auth.code,
        time: auth.time,
        code: this.code,
        isContract: this.isAgree? 1:'',
        openId: this.openId, name: this.name, idCard: this.idCard, phone: this.phone, hospitalId: this.hospitalId,
      });
      if (result.message === 'Error: Miss auth parameter.') {
        this.getTitle();
      } else {
        if (result.data == null || result.data == "" || result.data.studentIds == null) {
          this.$toast(result.message);
        } else {
          if (this.isAgree) {
            this.$toast(result.message);
          } 
        }
        this.$router.push(`/listAgree?openId=${this.$route.query.openId}&hospitalId=${this.$route.query.hospitalId}`);
      }
    },
  }
};
</script>
<style scope lang="less">
.top {
  padding: 0.3rem;
  font-size: 0.32rem;
  font-weight: bold;
  border-bottom: 1px solid #dddddd;
}

.btn {
  width: 5rem;
  font-size: 0.32rem;
  margin-top: 1rem;
  border: none;
  background: #5CC4AB;
}

.tip {
  padding: 0.3rem 0.2rem;
  padding-right: 0.1rem;
  text-align: left;
  color: #999;
}

.ali-title {
  position: fixed;
  bottom: 0.5rem;
  left: 0;
  margin: 0.3rem;
  text-align: left;
  line-height: 1.5em;
}

.no-result {
  width: 6.6rem;
  margin: 0.3rem auto;
  line-height: 1.5em;
}
</style>
